import dayjs from "dayjs";
import moment from "moment";
import { OrderType } from "../../types/types";
import { getOutletDetailsForSecondary } from "../../features/createSecondaryOrder/CreateSecondaryOrderService";
import { getConfigData } from "../../services/configurationService";

export const getActivityReminderPayload = (
  outletId: string | number,
  orderType: OrderType,
  rating: number | null
) => {
  const timeStamp = Date.now();
  const formattedDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
  const loginId = JSON.parse(localStorage.authContext).user.loginId;

  const activityId = `${outletId === "self" ? loginId : outletId}:${timeStamp}`;

  return {
    features: [
      {
        activityParam: "rating",
        status: rating,
        loginId,
        type: "orderDeliveryResponse",
        remarks: "",
        activityId,
      },
    ],
    extendedAttributes: {
      activity: "orderDeliveryResponse",
      mobTime: formattedDate,
      designation: orderType === OrderType.PRIMARY ? "supplier" : "retailer",
    },
  };
};

export const getStockCountColors = (inStock: boolean) => {
  if (inStock) {
    return {
      bg: "#F5FFFA",
      text: "#06A85E",
      border: "#06a85e47",
    };
  } else {
    return {
      bg: "#F4F4F4",
      text: "#7C7C7C",
      border: "#7c7c7c40",
    };
  }
};

export const getMOQColors = () =>{
  return {bgMOQ: "#FFF6EF", textMOQ: "#DB771D"}
}

type DayjsObject = {
  $L: string;
  $d: string;
  $y: number;
  $M: number;
  $D: number;
  $W: number;
  $H: number;
  $m: number;
  $s: number;
  $ms: number;
  $x: Record<string, unknown>;
  $isDayjsObject: true;
};

export const formatDate = (input: DayjsObject | string): string => {
  let formattedDate: string;

  if (typeof input === "object" && input.$isDayjsObject) {
    formattedDate = moment(input.$d).format("DD/MM/YY");
  } else if (typeof input === "string") {
    formattedDate = moment(input, "DD/MM/YY").format("DD/MM/YY");
  } else {
    return "-";
  }

  return formattedDate;
};

export const secondaryOrderDatePickerSx = {
  "& .MuiInputBase-input": {
    fontSize: "14px",
    fontWeight: 500,
    color: "#464646",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#EBEBEB",
  },
  "& .MuiOutlinedInput-root": {
    height: "38px",
  },
  "& .Mui-disabled": {
    opacity: 1,
    "-webkit-text-fill-color": "#464646",
  },
  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    border: "1px solid #EBEBEB !important",
  }, 
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    border: "1px solid #EBEBEB !important",
  }, 
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "1px solid #EBEBEB !important",
  }, 
  "& .MuiInputLabel-root": { 
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.6)",
    marginTop: "3px"
  },
};

export const customSx = {
  "& .MuiOutlinedInput-root": {
    height: "38px",
    "& fieldset": {
      borderColor: "#EBEBEB",
    },
    "&:hover fieldset": {
      borderColor: "#EBEBEB",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#EBEBEB",
    },
    "&.Mui-disabled fieldset": {
      borderColor: "#EBEBEB !important",
    },
    "&.Mui-disabled": {
      backgroundColor: "transparent",
    },
  },
  "& .MuiInputBase-input": {
    fontSize: "14px",
    fontWeight: 500,
    color: "#464646 !important",
    "&.Mui-disabled": {
      color: "#464646 !important",
    },
    "&:not(:empty)": {
      paddingTop: "3px", 
      marginTop: "9px"
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.6)",
    "&.Mui-focused, &.MuiInputBase-input:not(:empty) + .MuiInputLabel-root": {
      marginTop: "3px",
    },
  },
};


export const customSxV2 = {
  "& .MuiOutlinedInput-root": {
    height: "38px",
    paddingLeft: "8px",
    borderRadius: "20px",
    transition: "border-color 0.3s ease",
    "& fieldset": {
      borderColor: "#EBEBEB",
      transition: "border-color 0.3s ease",
    },
    "&:hover fieldset": {
      borderColor: "#EBEBEB",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#EBEBEB",
    },
    "&.Mui-disabled fieldset": {
      borderColor: "#EBEBEB !important",
    },
    "&.Mui-disabled": {
      backgroundColor: "transparent",
    },
  },
  "& .MuiInputBase-input": {
    fontSize: "12px",
    fontWeight: 500,
    color: "#464646 !important",
    "&.Mui-disabled": {
      color: "#464646 !important",
    },
    "&:not(:empty)": {
      paddingTop: "3px", 
      marginTop: "9px"
    },
  },
  "& .MuiInputBase-input::placeholder": {
    fontSize: "12px", 
    color: "#888 !important",
  },
  "& .MuiInputLabel-root": {
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.6)",
    "&.Mui-focused, &.MuiInputBase-input:not(:empty) + .MuiInputLabel-root": {
      marginTop: "3px",
    },
  },
};


export const autocompleteLableMarginFix = {
  "& .MuiInputLabel-root": {
    marginTop: "1px",
  },
}

export const generateBeatName = async (routeIdDetails: any, selectedSalesRepId: string, beatId: string) => {

  if (!beatId || beatId.length === 0) return ""

  const outletList = await getOutletDetailsForSecondary(selectedSalesRepId);
  const outletToRoutesMap: Record<string, Set<string>> = {};
  const routeToOutletsMap: Record<string, Set<string>> = {};
  outletList.forEach(({ beat, outletCode }) => {
    if (!beat || !outletCode) return;

    const beats = beat.split(',').map(b => b.trim());

    // Map outletCode => beats
    outletToRoutesMap[outletCode] = new Set(beats);

    // Map each beat => outletCode
    beats.forEach(b => {
        if (!routeToOutletsMap[b]) {
            routeToOutletsMap[b] = new Set();
        }
        routeToOutletsMap[b].add(outletCode);
    });
  });

  const beatNameMapping: Record<string, string> = {};
  const displayNameToBeatMapping: Record<string, string> = {};
  let routeIdNameMap: Record<string, any> = routeIdDetails;

  const beatDisplayNames: string[] = [];
  let routeIdSet = Object.keys(routeToOutletsMap);

  const filter1CountMap: Record<string, number> = {};

  Object.values(routeIdNameMap)
    .filter(ri => routeIdSet.includes(ri?.entityId))
    ?.forEach((node: any) => {
      const key = node?.filter1;
      if (key != null) {
        filter1CountMap[key] = (filter1CountMap[key] || 0) + 1;
      }
    });

  Object.values(routeIdNameMap).filter(ri => routeIdSet.includes(ri?.entityId))?.forEach((node: any) => {
      const isDuplicateName = (filter1CountMap[node?.filter1 ?? ""] ?? 0) > 1;
      const displayName = isDuplicateName
          ? (node?.filter1 ? `${node?.filter1}-${node?.entityId}` : node?.entityId)
          : (node?.filter1 ?? node?.entityId);

      beatDisplayNames.push(displayName);
      displayNameToBeatMapping[displayName] = node?.entityId;
      beatNameMapping[node?.entityId] = displayName;
  });

  return beatNameMapping?.[beatId] ?? "";

}

export const getRemovedFields = async (): Promise<string[]> => {

  const primaryCheckoutRemovedFieldsConfig = await getConfigData(
    "dms_configuration",
    "primaryCheckoutRemovedFields"
  )

  return (primaryCheckoutRemovedFieldsConfig[0]?.configValue as string[]) ?? [];
}

